module.exports = __webpack_public_path__ + "static/media/Strudel-BitcoinCash-Binance-Icon.349c23ea.png";